import React from 'react';
import { Button } from './ui/button';
import { Phone, Star, Zap, Crown, ArrowRight } from 'lucide-react';
import { advisorInfo, carModels } from '../data/mock';

const rebateModels = [
  { id: 'aruz', name: 'ARUZ', rebate: 3000 },
  { id: 'ativa', name: 'ATIVA', rebate: 2000 },
  { id: 'myvi', name: 'MYVI', rebate: 1000 },
  { id: 'axia', name: 'AXIA', rebate: 1000 },
];

const getCarImage = (id) => {
  const model = carModels.find(m => m.id === id);
  return model?.image || '';
};

const RebateCard = ({ model }) => {
  const image = getCarImage(model.id);

  const handleBook = () => {
    const msg = `[Website REBATE] Hi Syasyah, saya berminat dengan Perodua ${model.name}. Ada rebate RM${model.rebate.toLocaleString()} kan? Nak book!`;
    window.open(`${advisorInfo.whatsappLink}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <div className="relative group" data-testid={`rebate-card-${model.id}`}>
      <div className="bg-[#0D0D0D] rounded-2xl border-2 border-red-700/50 hover:border-red-500 overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(220,38,38,0.25)] hover:-translate-y-1">
        {/* Tags Row */}
        <div className="flex justify-between items-start px-3 pt-3">
          <span className="bg-red-600 text-white text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide">
            2026 New Stock
          </span>
        </div>

        {/* Car Image */}
        <div className="px-4 py-3 flex items-center justify-center h-28 md:h-32">
          <img
            src={image}
            alt={`Perodua ${model.name}`}
            className="max-h-24 md:max-h-28 w-auto object-contain group-hover:scale-110 transition-transform duration-500 drop-shadow-[0_0_20px_rgba(255,255,255,0.08)]"
          />
        </div>

        {/* Content */}
        <div className="px-3 pb-4 text-center">
          <h3 className="text-white font-bold text-sm md:text-base tracking-wide">
            PERODUA {model.name}
          </h3>

          {/* Rebate Amount - THE STAR */}
          <div className="my-2.5" data-testid={`rebate-amount-${model.id}`}>
            <p className="text-amber-400/70 text-[10px] font-semibold uppercase tracking-[0.2em]">Rebate</p>
            <p className="text-amber-400 text-3xl md:text-4xl font-black leading-none mt-0.5 drop-shadow-[0_0_15px_rgba(245,158,11,0.3)]">
              RM{model.rebate.toLocaleString()}
            </p>
          </div>

          {/* Book Button */}
          <button
            onClick={handleBook}
            data-testid={`rebate-book-btn-${model.id}`}
            className="w-full bg-red-600 hover:bg-red-500 text-white text-xs font-bold py-2 rounded-xl transition-all duration-200 flex items-center justify-center gap-1.5 mt-1"
          >
            Book Sekarang
            <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
};

const RebateSection = () => {
  const handleMainCTA = () => {
    const msg = `[Website REBATE] Hi Syasyah! Saya nampak ada rebate & free booking fee. Nak book sekarang!`;
    window.open(`${advisorInfo.whatsappLink}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <section id="rebate" className="relative py-14 md:py-20 overflow-hidden" data-testid="rebate-section">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#5C0000] via-[#8B0000] to-[#3B0000]" />

      {/* Subtle cross pattern */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      }} />

      {/* Top glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[150px] bg-red-500/20 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-amber-500/15 border border-amber-500/30 text-amber-400 px-5 py-2 rounded-full text-xs md:text-sm font-bold mb-5 animate-pulse">
            <Zap className="w-4 h-4" />
            TAWARAN TERHAD
          </div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white mb-3 tracking-tight leading-none">
            REBATE <span className="text-amber-400">TERKINI</span>
          </h2>

          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mt-5">
            <span className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold text-white/90">
              <Star className="w-3.5 h-3.5 text-amber-400 fill-current" />
              2026 NEW STOCK
            </span>
            <span className="text-white/30 hidden md:inline">|</span>
            <span className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold text-white/90">
              <Crown className="w-3.5 h-3.5 text-amber-400" />
              TOP BOOKING 2024/2025
            </span>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 mb-10 md:mb-14">
          {rebateModels.map((model) => (
            <RebateCard key={model.id} model={model} />
          ))}
        </div>

        {/* FREE BOOKING FEE Banner */}
        <div className="relative mb-10" data-testid="free-booking-fee-banner">
          <div className="bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-500 rounded-2xl p-[2px] shadow-[0_0_40px_rgba(245,158,11,0.2)]">
            <div className="bg-[#0D0D0D] rounded-[14px] py-6 md:py-8 px-6 text-center">
              <p className="text-amber-400/70 text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] mb-1">
                Tawaran Istimewa
              </p>
              <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight">
                FREE <span className="text-amber-400">BOOKING FEE</span>
              </h3>
              <p className="text-white/50 text-xs md:text-sm mt-2">
                Booking percuma untuk semua model di atas. Jangan lepaskan!
              </p>
            </div>
          </div>
        </div>

        {/* Main CTA */}
        <div className="text-center">
          <Button
            onClick={handleMainCTA}
            data-testid="rebate-whatsapp-cta"
            className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-500 hover:to-green-600 text-white font-bold px-8 md:px-12 py-4 md:py-5 rounded-2xl text-base md:text-lg transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-green-900/40"
          >
            <Phone className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3" />
            BOOK SEKARANG VIA WHATSAPP
          </Button>
          <p className="text-white/30 text-[10px] md:text-xs mt-4">
            *Tertakluk kepada terma & syarat. Rebate boleh berubah tanpa notis.
          </p>
        </div>
      </div>
    </section>
  );
};

export default RebateSection;
